import { API_AUTH } from "./common";

const TicketApi = {
  saveTicket: (params) =>
    API_AUTH.post(
      "ticket/save-ticket?UserName=" +
      params.Email +
      "&CongTy=" +
      params.CongTy +
      "&HoVaTen=" +
      params.TenNguoiTao +
      "&DienThoai=" +
      params.DienThoai +
      "&Email=" +
      params.Email +
      "&ChucNang=" +
      params.ChucNang +
      "&MoTa=" +
      params.MoTa +
      "&TieuDe=" +
      params.TieuDe,
      params.ImageList
    ),
  list: ({ trangThai, tieude, pageIndex, pageSize }) =>
    API_AUTH.get(
      `ticket/danh-sach-ticket?trangthai=${trangThai}&tieude=${tieude}&pageSize=${pageSize}&pageIndex=${pageIndex}`,
      {}
    ),
  ChiTietTicket: ( ticketId ) =>
    API_AUTH.get(
      `ticket/ChiTietTicket?ticketId=${ticketId}`,
      {}
    ),
  chiTietDanhGia: (TicketId) => {
    return API_AUTH.get(`ticket/ChiTietDanhGia?TicketId=${TicketId}`, {});
  },
  addDanhGia: (params) => API_AUTH.post("ticket/SaveDanhGia", params),
};

export default TicketApi;
